<div class="modal-header">
    <h4 class="modal-title">Zmiana hasła</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body" [formGroup]="form">
    <div class="mb-3">
        <label class="form-label">Obecne hasło</label>
        <input type="password" class="form-control" formControlName="actual_password">
    </div>
    <div class="mb-3">
        <label class="form-label">Nowe hasło</label>
        <input type="password" class="form-control" formControlName="password">
    </div>
    <div class="mb-3">
        <label class="form-label">Powtórz nowe hasło</label>
        <input type="password" class="form-control" formControlName="password_confirmation">
    </div>

    <div class="row">
        <div class="col-12">
            <div class="text-center mb-3">
                <button type="button" class="btn w-sm btn-light waves-effect" (click)="modal.dismiss()">Anuluj</button>
                <button type="submit" class="btn w-sm btn-success waves-effect waves-light me-1" [disabled]="!form.valid" (click)="save()">Zmień</button>
            </div>
        </div> <!-- end col -->
    </div>
</div>
